export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UiSelect.vue?vue&type=template&id=75f48d95&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiSelect.vue?vue&type=template&id=75f48d95&
// module id = 1119
// module chunks = 0